module.exports = __webpack_public_path__ + "img/coins-5.a6068ae4.png";